<template>
 <div id="typeItemDiv" :style="{width:getWidth}">
   <div class="tTText"
   :class="{tTSelected:selectedBool}" 
    @click="typeItemClick()">{{rebateTypeName}}</div>
   <div v-show="selectedBool" class="tILine" :class="{tTLineSelected:selectedBool}"></div> 
 </div>
</template>

<script>
 export default {
  props:{
      rebateTypeName:{type: String},
      selectedBool:{type: Boolean},
      currentIndex:{type: Number}
    }, 
   data () {
     return {

     }
   },
   components: {

   },
   methods:{
    typeItemClick(){
      // console.log("item 内的点击");
      // this.$emit("typeItemClick", this.currentIndex);
      this.$emit("itemclick", this.currentIndex);
    }
   },
   computed:{
    getWidth(){
      if (this.$store.state.initData.rebateType.length === 1) {
        return "100%"
      }else{
        return "50%"
      }
    }
   }
 }
</script>

<style>
#typeItemDiv{
  /* background-color: palegoldenrod; */
  /* width: 50%; */
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.tILine{
  margin-top: 2px;
  width: 25%;
  border:1px solid #CCC;
}
.tTText{
  color:#9A9A9A;
  font-size: smaller;
  font-weight: bold;
}
.tTSelected{
  color: #F54523;
  font-size: small;
}
.tTLineSelected{
  border:1px solid #FB4D44;
}


 
</style>


// WEBPACK FOOTER //
// src/views/TouTiaoApp/rebate/TypeItem.vue